import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { DASHBOARD_ICONS } from "../../../Helpers/ICONS";
import { FINAL_VOTE_VERIFICATION_ROUTES } from "../../../app/router/routes";
import LoaderComponent from "../../../components/Loader/LoaderComponent";
import NavBar from "../../../components/navbar/NavBar";
import { SectionColumn } from "../../../components/section";
import {
	STEPPER_STATUS,
	createStepper,
	disableAlert,
} from "../../../components/stepper/dynamicStepper";
import TraderStep1 from "../../trader/review/flow/TraderStep1";
import TraderStep4 from "../../trader/review/flow/TraderStep4";
import TraderStep5 from "../../trader/review/flow/TraderStep5";
import TraderStep6 from "../../trader/review/flow/TraderStep6";

export const stepperName = "FCView";

const FV_TraderView = () => {
	const stepper = [
		{
			step: "Business Details",
			status: STEPPER_STATUS.COMPLETED,
		},
		{
			step: "Current Product Details",
			status: STEPPER_STATUS.COMPLETED,
		},

		{
			step: "Certificates",
			status: STEPPER_STATUS.COMPLETED,
		},
		{ step: "Other Documents", status: STEPPER_STATUS.COMPLETED },
	];
	const [stepperData, setStepperData] = useState();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setStepperData(createStepper(stepperName, stepper));
		disableAlert();
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	}, []);

	const routeArray = [
		FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP01,
		FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP02,
		FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP03,
		FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP04,
	];
	return (
		<div>
			<LoaderComponent isOpen={isLoading} />
			<NavBar
				stepperName={stepperName}
				title={"Final Vote Verification Review"}
				tableIcon={DASHBOARD_ICONS.technicalCommittee}
				tableURL={FINAL_VOTE_VERIFICATION_ROUTES.VOTEREVIEW}
			/>

			{stepperData && (
				<SectionColumn className='w-full pt-1'>
					<Route path={FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP01}>
						<TraderStep1
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={0}
							nextCustomRoute={FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP02}
							readOnly
							hideFiles={true}
						/>
					</Route>

					<Route path={FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP02}>
						<TraderStep4
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={1}
							nextCustomRoute={FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP03}
							readOnly
						/>
					</Route>
					<Route path={FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP03}>
						<TraderStep5
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={2}
							nextCustomRoute={FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP04}
							readOnly
						/>
					</Route>
					<Route path={FINAL_VOTE_VERIFICATION_ROUTES.TRADER_STEP04}>
						<TraderStep6
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={3}
							nextCustomRoute={FINAL_VOTE_VERIFICATION_ROUTES.VOTEREVIEW}
							readOnly
						/>
					</Route>
				</SectionColumn>
			)}
		</div>
	);
};

export default FV_TraderView;
